import { createSelector } from 'reselect'

export const selectManager = state => state.managerDashboard || {}

export const selectManagerCanUseInbox = createSelector(selectManager,
    dashboard => dashboard.canUseInbox
)

export const selectManagerCanUseVoip = createSelector(selectManager,
    dashboard => dashboard.canUseVoip
)

export const selectManagerSuggestTourFeatureEnabled = createSelector(selectManager,
    dashboard => dashboard.suggestTourFeatureEnabled
)

export const selectManagerOpenUrlFeatureEnabled = createSelector(selectManager,
    dashboard => dashboard.openUrlFeatureEnabled
)
